import React, { useEffect, useMemo, useRef, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import SolidGauge from "highcharts/modules/solid-gauge";
import HighchartsMore from "highcharts/highcharts-more";
import {
  selectFinancialHealthScoreSummary,
  selectShowGaugeChart,
  setShowGaugeChart,
} from "../../../../../../rtk-query/features/dashboard/financialHealthScore/financialHealthScoreAnalysisSlice";
import { useDispatch, useSelector } from "react-redux";
import { Skeleton } from "primereact/skeleton";
import "./gaugechart.scss";
import { fhsGaugeStatus } from "../../../../../../utils/global";
import { getBase64FromSource, getRangeCategory } from "../../../../../../utils/Utils";
import { setChartImage } from "../../../../../../rtk-query/features/chartImage/chartImageSlice";

// Initialize Highcharts modules
HighchartsMore(Highcharts);
SolidGauge(Highcharts);

export const useIsMount = () => {
  const isMountRef = useRef(true);
  useEffect(() => {
    isMountRef.current = false;
  }, []);
  return isMountRef.current;
};

const GaugeChart = ({ showCohort, maxValue = 100 }) => {
  const dispatch = useDispatch();
  const showGaugeChart = useSelector((state) => selectShowGaugeChart(state));

  const bankPerformanceMetrics = useSelector(
    (state) =>
      // state.infiniteBankPerformanceMetricsReducer?.selectedBankMetricData
      //   ?.ungroupedResult,

      state.infiniteBankPerformanceMetricsReducer?.selectedBankMetricData,                    //New code - 28/05/2025
  );

  const { payload: FHSSummary } = useSelector((state) =>
    selectFinancialHealthScoreSummary(state),
  );
  const cohortAverage = bankPerformanceMetrics && bankPerformanceMetrics?.cohort && bankPerformanceMetrics?.cohort[0]?.average || 0;
  const FHSScore = bankPerformanceMetrics?.financial_health_score?.current;
  const matchedStatus = fhsGaugeStatus.find(
    (item) => item.status === getRangeCategory(FHSScore),
  );

  const [chartState, setChartState] = useState({
    currentValue: FHSScore,
    currentColor: "#6272D0",
    dataLabelMessage: matchedStatus?.description,
  });
  const chartRef = useRef(null);

  useEffect(() => {
    if (showCohort) {
      const chart = chartRef.current?.chart;
      const mouseOverHandler = (serie) => {
        setChartState((prevState) => ({
          ...prevState,
          currentValue: Number(Math.round(serie.data[0].y)),
          currentColor: serie.data[0].color,
          dataLabelMessage:
            serie.name === "Cohort" ? "Cohort Average" : FHSSummary?.status,
        }));
      };
      const mouseOutHandler = () => {
        setChartState((prevState) => ({
          ...prevState,
          currentValue: FHSScore,
          currentColor: "#6272D0",
          dataLabelMessage: matchedStatus?.description,
        }));
      };
      setTimeout(() => {
        chart?.series?.forEach((serie) => {
          serie.update({
            events: {
              mouseOver: (e) => mouseOverHandler(serie),
              mouseOut: mouseOutHandler,
            },
          });
          chart.container.onmouseleave = mouseOutHandler;
        });
      }, 1000);
    }
  }, [showGaugeChart, cohortAverage]);

  //   useEffect(async() => {
  //     debugger
  //    const base64Chart = await getBase64FromSource(".graph-container1");
  //     if (base64Chart) dispatch(setChartImage(base64Chart));
  // }, [showGaugeChart, cohortAverage]);
  // console.log(chartState);
  // console.log(bankPerformanceMetrics);
  const chartObj = useMemo(
    () => ({
      chart: {
        type: "solidgauge",
        // height: "55%",
        height: "36%",
        backgroundColor: "none",
      },
      title:
        // {
        //   text: `<p key=${Math.random()} class="gaugetitle" style="color:${
        //     chartState?.currentColor
        //   };">${chartState?.currentValue === undefined ? 0 : chartState?.currentValue}</p>`,
        //   useHTML: true,
        //   verticalAlign: "middle",
        //   align: "center",
        //   y: 55,
        // }
        null
      ,
      pane: {
        startAngle: -90,
        endAngle: 89.9,
        background: [
          showCohort && {
            backgroundColor: "#B5F7EB",
            borderColor: "#B5F7EB",
            borderRadius: 0,
            outerRadius: "175%",
            innerRadius: "160%",
            shape: "arc",
          },
          {
            outerRadius: "160%",
            innerRadius: "115%",
            backgroundColor: "#BBC3F3",
            borderColor: "#BBC3F3",
            shape: "arc",
          },
        ],
        center: ["50%", "90%"],
        size: "90%",
      },
      legend: {
        enabled: true,
        layout: "vertical",
        align: "right",
        verticalAlign: "middle",
        itemMarginTop: 10,
        itemStyle: {
          color: "#000",
          fontWeight: "bold",
        },
      },
      tooltip: {
        enabled: false,
      },
      yAxis: {
        min: 0,
        max: maxValue,
        lineWidth: 0,
        tickPositions: [],
        labels: {
          enabled: false,
        },
      },
      plotOptions: {
        series: {
          states: {
            inactive: {
              opacity: 1,
            },
          },
        },
        solidgauge: {
          dataLabels: {
            y: 0,
            x: 0,
            borderWidth: 0,
            useHTML: true,
            style: {
              pointerEvents: "none",
            },
            width: 20,
            format: `${showCohort
              ? ` <div class="position-relative graph-container1">
                    <div class="gauge-status-container">
                      <div
                        class="gauge-title"
                        style="color: ${chartState?.currentColor}; font-size: 4rem; font-weight: 600; line-height: 1.2;"
                      >
                        ${chartState?.currentValue === undefined ? 0 : chartState?.currentValue}
                      </div>
                      <div class="gauge-status"><!-- ${matchedStatus?.description} --></div>
                    </div>
                    <div class="gauge-label-container mt-1">
                      <div class="gauge-label w-50 d-inline-block">
                        <div class="dash-line fhs-square mx-2"></div>
                        <span class="fs-subdesc d-inline-block align-middle">Your FI</span>
                      </div>
                      <div class="gauge-label w-50 d-inline-block">
                        <div class="dash-line cohort-square mx-2"></div>
                        <span class="fs-subdesc d-inline-block align-middle">Cohort</span>
                      </div>
                    </div>
                  </div>`
              : ` <div class="gauge-status-container">
                    <div
                      class="gauge-title"
                      style="color: ${chartState?.currentColor}; font-size: 4rem; font-weight: 600; line-height: 1.2;"
                    >
                      ${chartState?.currentValue === undefined ? 0 : chartState?.currentValue}
                    </div>
                    <div class="gauge-status"><!-- ${matchedStatus?.description} --></div>
                  </div>`
              }`,
            verticalAlign: 'bottom',
          },
          radius: "100%",
          innerRadius: "75%",
        },
      },
      series: [
        showCohort && {
          name: "Cohort",
          data: [
            {
              color: "#56D8C0",
              radius: "175%",
              innerRadius: "160%",
              y: cohortAverage,
              borderWidth: 0,
              borderColor: "transparent",
            },
          ],

          states: {
            hover: {
              enabled: true,
              halo: false,
            },
          },
          dataLabels: {
            // format: `<p class="fhs-description">${chartState?.dataLabelMessage}</p>`,
            useHTML: true,
            borderWidth: 0,
            zIndex: 8,
            x: 0,
            y: 10,
          },
        },
        {
          name: "FHS",
          data: [
            {
              color: "#6272D0",
              radius: "160%",
              innerRadius: "115%",
              y: FHSScore,
              borderWidth: 0,
              borderColor: "transparent",
              dataLabels: {
                // format: `<p class="fhs-description mx-auto">${chartState?.dataLabelMessage}</p>`,
                useHTML: true,
                borderWidth: 0,
                zIndex: 8,
                x: 0,
                y: 10,
              },
            },
          ],
        },
      ],
      credits: {
        enabled: false,
      },
    }),
    [FHSScore, cohortAverage, chartState?.currentValue],
  );

  useEffect(() => {
    if (bankPerformanceMetrics?.financial_health_score?.current) {
      const updatedFHSScore =
        bankPerformanceMetrics?.financial_health_score?.current;
      const updatedMatchedStatus = fhsGaugeStatus.find(
        (item) => item.status === getRangeCategory(updatedFHSScore),
      );
      setChartState((prevState) => ({
        ...prevState,
        currentValue: updatedFHSScore,
        currentColor: "#6272D0", // Default color, update as needed
        dataLabelMessage: updatedMatchedStatus?.description,
      }));
    }
  }, [bankPerformanceMetrics]); // Re-run effect whenever bankPerformanceMetrics changes

  return (
    <div
      style={{
        margin: "0 -8rem",
        marginTop: "-3rem",
        position: "sticky",
        zIndex: 0,
      }}
    >
      {bankPerformanceMetrics?.financial_health_score?.current ? (
        <HighchartsReact
          highcharts={Highcharts}
          options={chartObj}
          ref={chartRef}
        />
      ) : (
        <div className="mx-0 d-flex flex-column justify-content-between rounded h-100">
          <div className="guage-semicircle-container d-flex flex-column overflow-hidden">
            <div className="semicircle d-flex justify-content-center">
              <Skeleton
                shape="circle"
                size="29rem"
                className="skeleton-circle"
                style={{ zIndex: -1 }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GaugeChart;
